import React, { ComponentProps } from 'react';
import { Modal } from '@fluentui/react';
import { SidebarProvider } from './SidebarProvider';

const LAYER_PROPS = { eventBubblingEnabled: true };

/**
 * Basic wrapper around fluent-ui modal to avoid rendering the content unless the modal is open.
 * Expected usage is for nested Forms/Workspaces which may fetch a significant amount of data or cause
 * complexity in tests due to duplicated data-testid's (Where the same content may be available from multiple sources).
 */
export default ({ children, isOpen, ...props }: ComponentProps<typeof Modal>) => {
  return (
    <Modal isOpen={isOpen} layerProps={LAYER_PROPS} {...props}>
      <div tabIndex={0}>{isOpen ? <SidebarProvider>{children}</SidebarProvider> : null}</div>
    </Modal>
  );
};
